import React, { useId } from "react";
import Select from 'react-select';
import { tailwindSelectStyles } from './reactSelectStyles';

const SelectInput = ({
  options = [],
  value = null,
  onChange,
  id,
  placeholder = 'Select...',
  isSearchable = true,
  isClearable = true,
  noOptionsMessage = () => 'No options found',
  className = '',
}) => {
  const generatedId = useId();
  const selectId = id || `select-${generatedId}`;

  const handleChange = (selectedOption) => {
    onChange(selectedOption);
  };

  return (
    <div className={`w-full ${className}`}>
      <Select
        id={selectId}
        options={options}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        isSearchable={isSearchable}
        isClearable={isClearable}
        styles={{
          ...tailwindSelectStyles,
          option: (base, state) => ({
            ...base,
            userSelect: 'none',
            cursor: 'pointer',
          }),
          singleValue: (base) => ({
            ...base,
            userSelect: 'text',
          }),
        }}
        classNamePrefix="react-select"
        noOptionsMessage={noOptionsMessage}
        theme={(theme) => ({
          ...theme,
          borderRadius: 8,
          colors: {
            ...theme.colors,
            primary25: '#eff6ff',
            primary: '#3b82f6',
          },
        })}
      />
    </div>
  );
};

export default SelectInput;